import { Switch, Space } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

function SwitchField (props) {
  const { id, type, label, labelYes='Yes', labelNo='No', ...rest } = props;
  return (
    <Space>
        <Switch id={id}
        checkedChildren={type === 'text' ? labelYes: <CheckOutlined />}
        unCheckedChildren={type === 'text' ? labelNo: <CloseOutlined />}
        {...rest}/>
        {label && 
          <label>{label}</label>
        }
    </Space>
    
  );
};

export default SwitchField;